export default "__VITE_ASSET__CHgY4m1d__";